// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Contexts
import {FormContext} from '../../contexts/form-context';

// Styles
import './reset-button.scss';

export default class ResetButton extends Component {
    getClass() {
        const {className} = this.props;

        return classnames('reset-button', 'button', className);
    }

    getProps() {
        return {
            className: this.getClass(),
            onClick: this.handleClick,
            type: 'button',
        };
    }

    handleClick = (event) => {
        const {onReset: onResetContext} = this.context;
        const {onReset} = this.props;

        event && event.preventDefault && event.preventDefault();

        if (onReset) {
            onReset();
        } else {
            onResetContext();
        }
    };

    render() {
        const {children = 'clear'} = this.props;

        return <button {...this.getProps()}>{children}</button>;
    }
}

ResetButton.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onReset: PropTypes.func,
};

ResetButton.contextType = FormContext;
